import React from 'react';
import PropTypes from 'prop-types';
import { TagV2, TagV2Size, TagV2Variant } from '@zola/zola-ui/src/components/Tag/TagV2';
import Link from '@zola/zola-ui/src/components/Link/Link';

const NavArrowLink = ({ children, href, newTag, icon, onClick, rel, role, target }) => (
  <Link arrow href={href} onClick={onClick} rel={rel} role={role} target={target}>
    {icon && <img src={icon} className="nav-link--icon" alt="" aria-hidden />}
    {children}{' '}
    {newTag && (
      <TagV2 variant={TagV2Variant.COVE} size={TagV2Size.SMALL}>
        New
      </TagV2>
    )}
  </Link>
);

NavArrowLink.propTypes = {
  href: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  target: PropTypes.string,
  rel: PropTypes.string,
  role: PropTypes.string,
  onClick: PropTypes.func,
  newTag: PropTypes.bool,
  icon: PropTypes.string,
};

export default NavArrowLink;
